export default "__VITE_PUBLIC_ASSET__76f002b0__"